import React from "react";

import { useFormattedMessage } from "hooks";
import Checkbox from "components/Checkbox";
import { createStructuredSelector } from "reselect";
import { connect } from "react-redux";
import { selectLocale } from "store/app/selectors";

const messages = {
    investmentCondition1kHeading: "investment_more_than_1k_meet_condition",
    investmentCondition10kHeading: "investment_more_than_10k_meet_condition",
    investmentConditionFirst: "freely_disposable_assets",
    investmentConditionSecond: "investment_does_not_exceed_twice",
};

function InvestmentChecks({
    className = "",
    isMoreThan1k,
    isMoreThan10k,
    moreThan100kFreelyDisposable = false,
    notMoreThanDoubleMonthlyIncome = false,
    setFieldValue,
    isLoading,
}) {
    const { formatMessage } = useFormattedMessage();

    return (
        <div className={`mt-4 ${className}`}>
            <p>{formatMessage(isMoreThan10k ? messages.investmentCondition10kHeading : messages.investmentCondition1kHeading)}</p>
            {isMoreThan1k && (
                <div className="check-section mt-7 flex space-between">
                    <Checkbox
                        isDisabled={isLoading}
                        inputId="conditionFirstFlag"
                        name="conditionFirstFlag"
                        value={moreThan100kFreelyDisposable}
                        label={formatMessage(messages.investmentConditionFirst)}
                        onChange={() => setFieldValue("moreThan100kFreelyDisposable", !moreThan100kFreelyDisposable)}
                    />
                </div>
            )}
            <div className="check-section mt-7 flex space-between">
                <Checkbox
                    isDisabled={isLoading}
                    inputId="conditionSecondFlag"
                    name="conditionSecondFlag"
                    value={notMoreThanDoubleMonthlyIncome}
                    label={formatMessage(messages.investmentConditionSecond)}
                    onChange={() => setFieldValue("notMoreThanDoubleMonthlyIncome", !notMoreThanDoubleMonthlyIncome)}
                />
            </div>
        </div>
    );
}

const mapStateToProps = createStructuredSelector({
    locale: selectLocale,
});

export default connect(mapStateToProps)(InvestmentChecks);
